import { render } from "./EmployeeDeniedRequests.vue?vue&type=template&id=26022f28"
import script from "./EmployeeDeniedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedRequests.vue?vue&type=script&lang=js"

import "./EmployeeDeniedRequests.vue?vue&type=style&index=0&id=26022f28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__